import React from "react";
import Header from "src/components/common/Header";
import Sidebar from "src/components/common/Sidebar";
import Footer from "src/components/common/Footer";
import JobListingsPage from "src/components/job-listings/JobListingsPage";
import { RODEO_PAGE_NAME } from "src/_config";

const JobListingsContainer: React.FC = () => {
  return (
    <>
      <Header variant="topbar" />
      <Sidebar page={RODEO_PAGE_NAME.JOB_LISTINGS} />
      <JobListingsPage />
      <Footer variant="dashboard" />
    </>
  );
};

export default JobListingsContainer;
